/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationMfaSettings } from './OrganizationMfaSettings';
import {
    OrganizationMfaSettingsFromJSON,
    OrganizationMfaSettingsFromJSONTyped,
    OrganizationMfaSettingsToJSON,
} from './OrganizationMfaSettings';

/**
 * 
 * @export
 * @interface GetOrganizationMfaSettings200Response
 */
export interface GetOrganizationMfaSettings200Response {
    /**
     * 
     * @type {OrganizationMfaSettings}
     * @memberof GetOrganizationMfaSettings200Response
     */
    data?: OrganizationMfaSettings;
}

/**
 * Check if a given object implements the GetOrganizationMfaSettings200Response interface.
 */
export function instanceOfGetOrganizationMfaSettings200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetOrganizationMfaSettings200ResponseFromJSON(json: any): GetOrganizationMfaSettings200Response {
    return GetOrganizationMfaSettings200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationMfaSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationMfaSettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : OrganizationMfaSettingsFromJSON(json['data']),
    };
}

export function GetOrganizationMfaSettings200ResponseToJSON(value?: GetOrganizationMfaSettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': OrganizationMfaSettingsToJSON(value.data),
    };
}

